import toggleCreatePostControls from './toggleCreatePostControls';

const init = (): void => {
  toggleCreatePostControls();
};

export default { init };
